import Home from '../home.jsx';


function App() {
  const category = "devices";

  return (
    <div>
      <Home category={category} />
    </div>
  );
}

export default App; 